import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatRippleModule } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MyCompanyProductRoles } from 'src/app/models/my_company_product_roles.model';
import { EmployeeService } from 'src/app/services/employee.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-lateral-menu-client',
  templateUrl: './lateral-menu-client.component.html',
  styleUrls: ['./lateral-menu-client.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLinkActive, RouterLink, MatIcon, MatRippleModule, NgStyle],
})
export class LateralMenuClientComponent {
  readonly employee = inject(EmployeeService);
  private readonly permissions = inject(PermissionsService);
  private readonly router = inject(Router);

  private readonly my_company_product_roles = toSignal(this.permissions.myCompanyProductRolesObservable, {
    initialValue: null as MyCompanyProductRoles | null,
  });

  readonly company_products_list = computed((): MyCompanyProductRoles[number][] => Object.values(this.my_company_product_roles() ?? {}));
  readonly total_actions_required = computed((): number => this.employee.totalActionsRequired());

  openPendingSlackChats(event: Event): void {
    event.preventDefault();
    void this.router.navigate(['/clients', 'my-profile', 'chats']);
  }

  isCompanyProductActive(company_product_id: number): boolean {
    const match = this.router.url.match(/\/clients\/company-products\/(\d+)/);

    return match?.[1] === String(company_product_id);
  }

  goToCompanyProduct(company_product_id: number): void {
    void this.router.navigate(['/clients', 'company-products', company_product_id, 'okr-and-metrics']);
  }
}
